import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { useEffect } from 'react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const spacing1_25x = 'var(--spacing-1-25x, 1.25rem)'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { useFlag } from '@calendly/feature-check-react'

import { resetTheme } from 'initializers/theme'
import { useFeatures } from 'components/use_organization'
import Branding from 'components/branding'
import _StyledContainer from "layout-StyledContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/layout.js?styleId=StyledContainer";


const StyledContainer = /*#__PURE__*/styled('div', null, {
  displayName: "StyledContainer",
  styles: _StyledContainer
})

export const Layout = ({
  children,
  expanded = false,
  hiddenSidebar = false,
  hideBranding = false,
  ...props
}) => {
  const { data } = useFeatures()
  const isPhone = useDeviceType('isPhone')
  const isTabletUp = useDeviceType('isTabletUp')
  const isTabletDown = useDeviceType('isTabletDown')
  const isDesktopUp = useDeviceType('isDesktopUp')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  useEffect(() => {
    if (data) {
      const { custom_theme_allowed: customThemeAllowed } = data
      if (!customThemeAllowed) {
        resetTheme()
      }
    }
  }, [data])

  return (
    <StyledContainer
      data-id="personalized-confirmation-container"
      {...props}
      expanded={expanded}
      hiddenSidebar={hiddenSidebar}
      isPhone={isPhone}
      isTabletUp={isTabletUp}
      isTabletDown={isTabletDown}
      isDesktopUp={isDesktopUp}
      bookingAppRedesign={bookingAppRedesign}
      data-container="booking-container"
      fitContent={bookingAppRedesign}
    >
      {!hideBranding && <Branding />}
      {children}
    </StyledContainer>
  )
}

Layout.propTypes = {
  expanded: PropTypes.bool,
  hiddenSidebar: PropTypes.bool,
  hideBranding: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}
